/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * POST /distributors
 * @export
 * @interface PostDistributorSuccessResponse
 */
export interface PostDistributorSuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof PostDistributorSuccessResponse
     */
    status: number;
    /**
     * エラーメッセージ。原則英語。
     * @type {string}
     * @memberof PostDistributorSuccessResponse
     */
    message: string;
}

export function PostDistributorSuccessResponseFromJSON(json: any): PostDistributorSuccessResponse {
    return PostDistributorSuccessResponseFromJSONTyped(json, false);
}

export function PostDistributorSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostDistributorSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function PostDistributorSuccessResponseToJSON(value?: PostDistributorSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
    };
}

